import React from "react"
import Router from "./router/router"
import CurrentScreen from "./router/current-screen"

// Import Cloudscape global styles
import "@cloudscape-design/global-styles/index.css"

function App() {
  return (
    <Router>
      <CurrentScreen />
    </Router>
  );
}

export default App;
